"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.initializeOpenStreetMaps = void 0;
const initializeMap_1 = __importDefault(require("./openstreetmap/map/initializeMap"));
const addMarkersFromLocation_1 = __importDefault(require("./openstreetmap/map/addMarkersFromLocation"));
const observeSize_1 = __importDefault(require("./openstreetmap/sidebar/observeSize"));
const expandOnClick_1 = __importDefault(require("./openstreetmap/sidebar/expandOnClick"));
const fetchEndpointPosts_1 = __importDefault(require("./openstreetmap/api/fetchEndpointPosts"));
const addEndpointPosts_1 = __importDefault(require("./openstreetmap/post/addEndpointPosts"));
const setMapTiles_1 = __importDefault(require("./openstreetmap/map/setMapTiles"));
const mapHelpers_1 = require("./openstreetmap/map/mapHelpers");
const accessibilityFeatures_1 = __importDefault(require("./openstreetmap/accessibility/accessibilityFeatures"));
const zoomMarker_1 = __importDefault(require("./openstreetmap/map/zoomMarker"));
const postAdded_1 = __importDefault(require("./openstreetmap/post/postAdded"));
const postMarkerPairs_1 = __importDefault(require("./openstreetmap/post/postMarkerPairs"));
const createMarker_1 = __importDefault(require("./openstreetmap/createMarker/createMarker"));
const createTooltip_1 = __importDefault(require("./openstreetmap/createMarker/createTooltip"));
const showIfNotEmpty_1 = __importDefault(require("./openstreetmap/sidebar/showIfNotEmpty"));
const showPost_1 = __importDefault(require("./openstreetmap/sidebar/showPost"));
const tooltipListener_1 = __importDefault(require("./openstreetmap/sidebar/tooltipListener"));
const handlePostsLoadingSpinner_1 = __importDefault(require("./openstreetmap/sidebar/handlePostsLoadingSpinner"));
class OpenStreetMap {
    constructor(container) {
        this.container = container;
        this.baseClass = 'c-openstreetmap';
        this.settings = this.getSettings();
        const initializeMapInstance = new initializeMap_1.default(this.container);
        const [map, markers] = initializeMapInstance.create();
        if (map && markers) {
            this.setupMap(map, markers);
            this.setupFeatures(map, markers);
        }
    }
    setupMap(map, markers) {
        new setMapTiles_1.default(this.container, map);
        (0, mapHelpers_1.setView)(map, JSON.parse(this.settings.startposition));
        map.zoomControl.setPosition('bottomright');
        (0, mapHelpers_1.invalidateSize)(map);
    }
    setupFeatures(map, markers) {
        const zoomMarkerInstance = new zoomMarker_1.default(map, markers);
        const handlePostsLoadingSpinnerInstance = new handlePostsLoadingSpinner_1.default(this.container);
        const createMarkerInstance = new createMarker_1.default(this.container);
        const createTooltipInstance = new createTooltip_1.default(this.container);
        const expandOnClickInstance = new expandOnClick_1.default(this.container, map, this.baseClass);
        const showPostInstance = new showPost_1.default(this.container, map, this.baseClass, zoomMarkerInstance);
        const showIfNotEmptyInstance = new showIfNotEmpty_1.default(this.container, this.baseClass);
        const observeSizeInstance = new observeSize_1.default(this.container, this.baseClass);
        const tooltipListenerInstance = new tooltipListener_1.default(this.container, map, markers);
        const postMarkerPairsInstance = new postMarkerPairs_1.default(this.container);
        const accessibilityFeaturesInstance = new accessibilityFeatures_1.default(this.container, map, markers, zoomMarkerInstance, this.baseClass);
        const addMarkersFromLocationInstance = new addMarkersFromLocation_1.default(this.container, map, markers, postMarkerPairsInstance, createMarkerInstance, createTooltipInstance);
        const postAddedInstance = new postAdded_1.default(this.container, addMarkersFromLocationInstance);
        const addEndpointPostsInstance = new addEndpointPosts_1.default(this.container, map, markers);
        const fetchEndpointPostsInstance = new fetchEndpointPosts_1.default(this.container, this.settings.endpoint);
    }
    getSettings() {
        var _a, _b;
        return {
            endpoint: (_a = this.container.getAttribute('data-js-map-posts-endpoint')) !== null && _a !== void 0 ? _a : '',
            startposition: (_b = this.container.getAttribute('data-js-map-start-position')) !== null && _b !== void 0 ? _b : ''
        };
    }
}
function initializeOpenStreetMaps() {
    const componentElements = [...document.querySelectorAll('.c-openstreetmap')];
    componentElements.forEach((element) => {
        new OpenStreetMap(element);
    });
}
exports.initializeOpenStreetMaps = initializeOpenStreetMaps;
exports.default = OpenStreetMap;
